export default __webpack_public_path__ + "static/assets/434bfed5aad8103750233ca11ae48dbd.svg";